import { createUseStyles } from 'react-jss'
import { backgroundGrey } from '../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  videoPicture: {
    maxWidth: '100%'
  },
  imagePlaceholder: {
    width: '100%',
    height: '100%',
    backgroundColor: backgroundGrey
  }
})

export default useStyles
